export default __webpack_public_path__ + "static/media/intellectualnEnergSis.13a98eb5.pdf";